import { error, finish } from '../../../modules/user/actions/signup';

import api from '../../../api';

export function request(dispatch, action) {
    let obj = Object.assign({}, action);

    delete obj.type;
    delete obj.dayOfBirth;
    delete obj.monthOfBirth;
    delete obj.yearOfBirth;

    api.post('/user', obj).then(
        ({ data }) => {
            data.signup = true;
            data.authenticated = true;
            dispatch(finish(data));
        },
        ({ errors }) => dispatch(error(errors))
    );
}
